import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
} from '@design-system';

interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box className="flex min-h-screen flex-col">
      <AppBar position="static" elevation={1}>
        <Toolbar className="gap-4">
          <Typography
            variant="h6"
            className="cursor-pointer"
            onClick={() => navigate('/jobs')}
          >
            Pioneer Marketplace
          </Typography>
          <Box className="ml-auto flex gap-2">
            <Button
              color="inherit"
              variant={location.pathname === '/jobs' ? 'outlined' : 'text'}
              onClick={() => navigate('/jobs')}
            >
              Jobs
            </Button>
            <Button
              color="inherit"
              variant={location.pathname === '/my-activity' ? 'outlined' : 'text'}
              onClick={() => navigate('/my-activity')}
            >
              My Activity
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className="flex-1 py-6">
        {children}
      </Container>
    </Box>
  );
}

export default Layout;
